import { createTheme } from "@mui/material/styles";
import type { Theme } from "@mui/material/styles";

// Brand tokens
const brandPrimary = "#1c4480"; // Deep blue — Records Monitor brand
const brandSecondary = "#2e7d32"; // Green accent

export const lightPalette = {
  mode: "light" as const,
  primary: {
    main: brandPrimary,
    light: "#4d6faf",
    dark: "#0d1f3c",
    contrastText: "#ffffff",
  },
  secondary: {
    main: brandSecondary,
    light: "#60ad5e",
    dark: "#1b5e20",
    contrastText: "#ffffff",
  },
  background: {
    default: "#f5f7fa",
    paper: "#ffffff",
  },
  text: {
    primary: "#1a1a2e",
    secondary: "#5c5c7a",
  },
};

export const darkPalette = {
  mode: "dark" as const,
  primary: {
    main: "#4d6faf",
    light: "#7a9dd4",
    dark: brandPrimary,
    contrastText: "#ffffff",
  },
  secondary: {
    main: "#60ad5e",
    light: "#91df8b",
    dark: brandSecondary,
    contrastText: "#000000",
  },
  background: {
    default: "#0d1117",
    paper: "#161b22",
  },
  text: {
    primary: "#e6edf3",
    secondary: "#8b949e",
  },
};

/**
 * Create the app MUI theme for a given color mode.
 * @param mode - "light" or "dark"
 */
export function createAppTheme(mode: "light" | "dark"): Theme {
  const palette = mode === "light" ? lightPalette : darkPalette;
  return createTheme({
    palette,
    typography: {
      fontFamily: '"Inter", "Roboto", "Helvetica Neue", Arial, sans-serif',
      h1: { fontWeight: 700 },
      h2: { fontWeight: 600 },
      h3: { fontWeight: 600 },
    },
    shape: {
      borderRadius: 8,
    },
    components: {
      MuiDrawer: {
        styleOverrides: {
          paper: {
            boxSizing: "border-box",
          },
        },
      },
    },
  });
}

export const lightTheme = createAppTheme("light");
export const darkTheme = createAppTheme("dark");
